/**
 * 标准列表按钮相关处理
 */
import interceptorsModule from '@/config/interceptors'

export default () => ({
  updated() {
    const tableName = this.$router.currentRoute.params.tableName;
    setTimeout(() => {
      switch (tableName) {
        case 'PS_C_PRO_GROUP':
          /* this.PRO_GROUP_getStrategy();
          let dom = null;
          if (this.proGropStrategy === '0') {
            // 手动,沿用老逻辑,隐藏定制
            dom = $('.PROGROUPLISTIMPORT');
            dom[0].style.display = 'none';
          } else if (this.proGropStrategy === '1') {
            // 自动生成,定制,隐藏标准'导入'
            dom = document.getElementById('actionIMPORT');
            if (dom) dom.style.display = 'none';
          } */
          break;
        case 'OC_B_COMPENSATE_ORDER':
          console.log(tableName);
          break;

        default:
          break;
      }
    }, 100);

    // 隐藏标准界面按钮
    const config = new Map([
      ['actionADD', ['PS_C_SKU_PUSH_WMS_MID']], // 新增
      ['actionEXPORT', ['ORDEREXPORTVIEW']], // 导出
    ]);
    [...config.keys()].forEach(action => {
      config.get(action).forEach(i => {
        if (i == tableName) {
          const node = document.getElementById(action);
          if (node) node.style.display = 'none';
        }
      })
    })
  },
  methods: {
    TOEXAMINEABNORMAL() {
      const data = this.$store.state[R3.getModuleName()]
      const ids = data.buttons.selectIdArr
      if (ids.length) {
        $fcWarn({
          className: 'ark-dialog',
          title: t('提示'),
          content: `${t('是否确定该操作？')}`,
          mask: true,
          showCancel: true,
          onOk: () => {
            vm.service.orderCenter.auditOrder({
              isAsync: false,
              ids,
              type: '1',
              isCheck: 0
            }).then(res => {
              if (res.data.code === 0) {
                vm.$Message.success(res.data.message);
                $('.ListsForm-button #search')[0].click()
              } else if (res.data.code == 1) {
                const err = res.data.message
                let renderInfo = {
                  props: {
                    height: 200,
                    stripe: true,
                    columns: [
                      {
                        type: 'index',
                        fixed: 'left'
                      },
                      {
                        title: t('信息'),
                        key: 'message',
                      },
                    ],
                    data: res.data.data.map(i => {
                      return {
                        message: i
                      }
                    }),
                  },
                }
                const onOkFn = async function (node) {
                  await vm.service.common.publicUrlParams('/api/cs/oc/oms/v1/audit/confirm', {...params, node}).then(res => {
                    if (res.data.code == 0) {
                      vm.$Message.success(res.data.message);
                    } else if (res.data.code == 1) {
                      const errList = res.data.data || []
                      $fcError({
                        render: (h) => h('pre', {
                          style: {
                            'max-height': '200px',
                            'line-height': '32px',
                            'overflow': 'auto',
                            'padding': '6px'
                          },
                          domProps: {
                            innerHTML: errList.join('\n'),
                          },
                        })
                      })
                    }
                    this.$Modal.remove();
                  })
                }
                this.$Modal.confirm({
                  className: 'ark-dialog',
                  width: '500',
                  title: err,
                  mask: true,
                  draggable: true,
                  render: (h) => h('Table', renderInfo),
                  footerRender: (h) => {
                    let btn = []
                    btn.push(
                      h(
                        'Button',
                        {
                          props: {
                            type: 'default'
                          },
                          on: {
                            click: () => {
                              vm.$Modal.remove();
                            },
                          },
                        },
                        t('取消')
                      )
                    );
                    btn.push(
                      h(
                        'Button',
                        {
                          props: {
                            type: 'primary'
                          },
                          on: {
                            click: () => {
                              onOkFn(1)
                            },
                          },
                        },
                        t('审核当前勾选订单')
                      )
                    );
                    btn.push(
                      h(
                        'Button',
                        {
                          props: {
                            type: 'primary'
                          },
                          on: {
                            click: () => {
                              onOkFn(2)
                            },
                          },
                        },
                        t('合并订单并审核')
                      )
                    );
                    return h('div', {}, btn);
                  },
                })
              } else {
                $fcError(res.data.message)
              }
            })
          }
        });
      } else {
        $fcError(t('请先勾选要操作的数据！'))
        return
      }
    },
    async ST_C_GIFT_REDEMPTION_STRATEGY_COPY() {
      const data = this.$store.state[R3.getModuleName()]
      const id = data.buttons.selectIdArr[0]
      const param = new FormData();
      param.append('ID', id)
      await this.service.common.publicUrlParams('/api/cs/oc/oms/stCGiftRedemptionStrategyCopy', param).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          $('.R3-buttonList #refresh')[0].click()
        }
      })

    },
    async REPRODUCE_CONVERSION(btn) {
      const data = this.$store.state[R3.getModuleName()]
      const select = [...data.buttons.selectArr].map(i => {
        let x = {}
        for (const key in i) {
          x[key] = i[key].refobjid || i[key].val
        }
        return x
      })
      await this.service.common.publicUrlParams('/api/cs/oc/oms/abnormal/orderTransfer', select).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          $('.R3-buttonList #refresh')[0].click()
        }
      })
    },
    // 数据权限- 添加全部
    async PERMISSION_ADD_ALL() {
      interceptorsModule.permission.PERMISSION_ADD_ALL()
    },
    ORDER_CONFIRM() {
      // LMA工单 - 工单确认
      const page = this.$store.state[R3.getModuleName()]
      const ids = page.buttons.selectIdArr
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/lma/orderConfirm', { ids }).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          $('.R3-buttonList #refresh')[0].click()
        }
      })
    },
    async MQ_PUBLISH() {
      await this.service.systemConfig.mqEnableAll({}).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          $('.R3-buttonList #refresh')[0].click()
        }
      })
    },
    async actionBeforeHandle(btn) {
      const data = this.$store.state[R3.getModuleName()]
      let query = null
      const select = data.buttons.selectIdArr
      await this.$refs.R3listform.getFormData().then(res => {
        query = res
      })
      if (btn.webname == "exportConsignmentStorage") {
        const SELECT_DATE = this.$refs.R3listform.$children[0].$children[0].$children[0].$children[0].valuedata
        SELECT_DATE != '' && (query.SELECT_DATE = SELECT_DATE)
      }
      return {
        webname: btn.webname,
        query,
        selectRows: data.buttons.selectArr,
        select,
        arr_ids: select,
        str_ids: select.join()
      }
    },
    async AC_F_COMM_CUSTOM_ACTION(btn) {
      const btn_api = {
        "AC_F_SOURCE_REFUND_EXPORT": 'acFSourceRefundExport', // 对账来源退款-导出
        "AC_F_SOURCE_RETURN_EXPORT": 'acFSourceReturnExport', // 对账来源退单-导出
        "AC_F_SOURCE_ORDER_EXPORT": 'acFSourceOrderExport', // 对账来源订单-导出
        "AC_F_SETTLE_BIL_CANCEL": 'cancelSettleBill', // 对账结算单-取消结算
        "AC_F_CONFIRM_BILL_MANUAL_SETTLE": 'manualSettle', // 对账单-手动结算
        "AC_F_CONFIRM_BILL_RECONFIRM": 'reBill', // 对账单-重新对账
        "AC_F_SETTLE_BIL_DEL": 'delSettleBill' // 结算单-删除
      }
      // /api/cs/sg/consignmentStorage/export
      const { query, arr_ids, webname } = await this.actionBeforeHandle(btn)
      if (!Object.keys(query).length && arr_ids.length < 1) {
        $fcError(t('请填写筛选条件或勾选要操作的数据！'))
        return
      }
      const param = {
        TABLE: this.$router.currentRoute.params.tableName,
        IDS: arr_ids,
        CONDITION: query,
        BUSINESS: {}
      }
      $fcWarn({
        className: 'ark-dialog',
        title: t('提示'),
        content: `${t('是否确定该操作？')}`,
        mask: true,
        showCancel: true,
        onOk: () => {
          this.service.financeCenter[btn_api[webname]](param).then(res => {
            if (res.data.code == 0) {
              switch (webname) {
                case 'AC_F_SETTLE_BIL_CANCEL':
                  $fcWarn({
                    title: t('提示'),
                    content: res.data.message
                  });
                  break;
                case 'AC_F_SOURCE_ORDER_EXPORT':
                case 'AC_F_SOURCE_RETURN_EXPORT':
                case 'AC_F_SOURCE_REFUND_EXPORT':
                  this.myHook.asyncTask.call() // 唤出异步任务列表
                  break;
                default:
                  this.$Message.success(res.data.message)
                  break;
              }
              const arr = ['exportConsignmentStorage', 'AC_F_SOURCE_ORDER_EXPORT', 'AC_F_SOURCE_RETURN_EXPORT', 'AC_F_SOURCE_REFUND_EXPORT']
              if (!arr.includes(webname)) { // 导出不需要刷新页面
                $('.R3-buttonList #refresh')[0].click()
              }
            }
          });
        }
      });
    },
    async EXPORT_CONSIGNMENT_STORAGE(btn) {
      const btn_api = {
        "RPT_GOODS_MARKET_STATISTICS_REPORT": 'goodsMarketStatisticsExport', // 商品销售统计报表-导出
        "exportConsignmentStorage": 'consignmentStorageExport', // OMS与SAP寄售库存核对-导出
        "RPT_NOTSENT_PRESALE_ORDER_TRANSFER_ITEM_EXPORT": 'saleOrderNoSendTransferItemExport', // 预售订单未发调拨明细-导出
        "STORE_DISTRIBUTION_EXPORT": 'storeDistributionExport', // 门店配货到货率查询-导出
      }
      const { query, webname, selectRows } = await this.actionBeforeHandle(btn)
      const searchdata = {
        table: this.$router.currentRoute.params.tableName,
        startindex: 0,
        fixedcolumns: query,
        column_include_uicontroller: true,
        isolr: false
      }
      if (webname == 'STORE_DISTRIBUTION_EXPORT') {
        searchdata.selectRows = selectRows
      }
      const param = new FormData();
      param.append('searchdata', JSON.stringify(searchdata));

      $fcWarn({
        className: 'ark-dialog',
        title: t('提示'),
        content: `${t('是否确定该操作？')}`,
        mask: true,
        showCancel: true,
        onOk: () => {
          $utils.mainContentLoading(true)
          this.service.financeCenter[btn_api[webname]](param).then(res => {
            if (res.data.code == 0) {
              switch (webname) {
                case 'exportConsignmentStorage':
                  window.location = `/p/cs/download?filename=${res.data.data}`
                  break;
                case 'RPT_NOTSENT_PRESALE_ORDER_TRANSFER_ITEM_EXPORT':
                case 'STORE_DISTRIBUTION_EXPORT':
                case 'RPT_GOODS_MARKET_STATISTICS_REPORT':
                  this.myHook.asyncTask.call() // 唤出异步任务列表
                  break;
                default:
                  this.$Message.success(res.data.message)
                  break;
              }
              const arr = ['exportConsignmentStorage', 'RPT_NOTSENT_PRESALE_ORDER_TRANSFER_ITEM_EXPORT', 'STORE_DISTRIBUTION_EXPORT', 'RPT_GOODS_MARKET_STATISTICS_REPORT']
              if (!arr.includes(webname)) { // 导出不需要刷新页面
                $('.R3-buttonList #refresh')[0].click()
              }
            }
          }).finally(() => {
            $utils.mainContentLoading()
          }) ;
        }
      });
    },
    SgBWmsToInventoryChangeNoticeCmd() {
      const data = this.$store.state[R3.getModuleName()]
      const select = data.buttons.selectIdArr
      if (select.length < 1) {
        $fcError(t('请先勾选要操作的数据！'))
        return
      }
      $fcWarn({
        className: 'ark-dialog',
        title: t('提示'),
        content: `${t('是否确定转化？')}`,
        mask: true,
        showCancel: true,
        onOk: () => {
          const param = new FormData();
          param.append('ids', select.join())
          this.service.inventoryCenter.updateByWmsBillNo(param).then(res => {
            if (res.data.data.code == 0) {
              this.$Message.success(res.data.data.message)
              $('.R3-buttonList #refresh')[0].click()
            } else {
              $fcError(res.data.data.message)
            }
          });
        }
      });
    },
    async BACK_MODIFY(btn) {
      // 商品效期策略 - 反审核并修改
      const { query, str_ids } = await this.actionBeforeHandle(btn)
      if (!str_ids) {
        $fcError(t('请勾选要操作的数据！'))
        return
      }
      $fcWarn({
        className: 'ark-dialog',
        title: t('提示'),
        content: `${t('是否确定对该订单进行【反审核并修改】操作？')}`,
        mask: true,
        showCancel: true,
        onOk: () => {
          this.service.strategyPlatform.backAndModify({ objid: str_ids }).then(res => {
            if (res.data.code == 0) {
              $utils.tabCloseAppoint(this);
              this.$destroy(true);
              this.$store.commit("global/tabOpen", {
                  id: str_ids,
                  type: "V",
                  tableName: "ST_C_EXPIRY_DATE",
                  tableId: '249231388',
              });
            }
          });
        }
      });

    },
    async BILL_DELETE(obj) {
      // 通用/支付宝/拼多多/抖音原始账单、平台账单表、对账单 - 删除
      const { query, select } = await this.actionBeforeHandle(obj)
      if (!Object.keys(query).length && select.length < 1) {
        $fcError(t('请填写筛选条件或勾选要操作的数据！'))
        return
      }
      const param = {
        table: this.$router.currentRoute.params.tableName,
        del_type: select.length ? 'by_ids' : 'by_condition',
        ids: select.join(),
        condition: query
      }
      $fcWarn({
        className: 'ark-dialog',
        title: t('提示'),
        content: `${t('是否确定删除要操作的账单？')}`,
        mask: true,
        showCancel: true,
        onOk: () => {
          this.service.financeCenter.delCfmBill(param).then(res => {
            if (res.data.code == 0) {
              this.$Message.success(res.data.message)
              // $('#AC_F_COMMON_ORIGINAL_BILL #refresh').trigger('click')
              $('.R3-buttonList #refresh')[0].click()
            }
          });
        }
      });
    },
    // 组合商品-查询商品编码生成策略
    PRO_GROUP_getStrategy: _.throttle(
      function () {
        const formData = new FormData();
        formData.append('param', 'ps_c_pro_group');
        formData.append('type', '组合商品列表');
        this.service.commodityCenter.getCodeAndParam(formData).then((res) => {
          const data = res.data;
          if (data.code === 0) {
            const {
              ps_c_pro_group_sku_code_rule: tempRule, // 决定导入的模板
            } = data.data;
            this.proGropStrategy = tempRule;
          } else {
            this.$Message.warning(data.message);
          }
        });
      },
      3000,
      { trailing: false }
    ),
    async "CUSTOMIZED/VIPCOM_DISTRIBUTION_COPY"() {
      const _id = this.$store.state[R3.getModuleName()].buttons.selectIdArr[0]
      const param = {
        "originalId": _id
      }
      const params = new FormData()
      params.append('param', JSON.stringify(param))
      this.service.orderCenter.checkCopyDistribution(param).then(res => {
        const goTo = function () {
          vm.$store.commit("global/tabOpen", {
            type: "V",
            url: `/SYSTEM/TABLE_DETAIL/V/OC_B_VIPCOM_DISTRIBUTION/24733/${_id}?ISCOPY=Y&OID=${_id}`,
          });
        }
        if (res.data.code == 2) {
          $fcWarn({
            className: 'ark-dialog',
            title: t('提示'),
            content: `${res.data.message}`,
            mask: true,
            showCancel: true,
            onOk: () => {
              goTo()
            }
          });
        } else if (res.data.code == 0) {
          goTo()
        }
      });
    }
  },
});
